module.exports = __webpack_public_path__ + "static/media/ever_pano_05-min.5af60cd5.JPG";